import ProductCardsPresenter from "../../../product-cards/presenter/product-cards.js";

import {
  removeElement
} from "../../../render/render.js";

import {
  sendXhr
} from "../../../../utils/send-xhr/send-xhr.js";

import {
  ActionType as FavoriteDataActionType,
  RequestAction,
  CONNECTOR_URL
} from "../../favorite-data/const.js";
export default class ProductsList extends ProductCardsPresenter {
  constructor(listElement) {
    super(listElement);

    this._handleFavoriteDataChange = this._handleFavoriteDataChange.bind(this);
  }

  init() {
    super.init();

    if (window.FavoriteData) {
      window.FavoriteData.addObserver(this._handleFavoriteDataChange);
    }
  }

  destroy() {
    super.destroy();

    if (window.FavoriteData) {
      window.FavoriteData.removeObserver(this._handleFavoriteDataChange);
    }
  }

  _processRemoveProductFromFavorites(productId, generatedId) {
    const itemToRemove = this._itemsPresenter[generatedId];
    itemToRemove.destroy();

    const elementToRemove = itemToRemove.getElement();
    this._animation.fadeOut(
        elementToRemove,
        null,
        () => {
          removeElement(elementToRemove);
        }
    );

    delete this._itemsPresenter[generatedId];

    const requestArgs = {
      body: [
        `action=${RequestAction.REMOVE_PRODUCT}`,
        `product_id=${productId}`
      ],
      connectorUrl: CONNECTOR_URL,
      loadCallback: (response) => {

        const data = JSON.parse(response);


        if (data.error) {
          console.error(data.error);
        }
      },
    };
    sendXhr(requestArgs);
    if (Object.keys(this._itemsPresenter).length > 0) {
      return;
    }
  }

  _handleFavoriteDataChange(action, payload) {
    switch (action) {
      case FavoriteDataActionType.REMOVE_PRODUCT:
        this._processRemoveProductFromFavorites(payload.productId, payload.generatedId);
        break;
    }
  }
}
